import PropTypes from "prop-types";
import React, { useCallback, useRef, useState } from "react";
import { useMount } from "../../hooks";
import "./style.scss";
import game_small from "./img/game_small.png";
import game_big from "./img/game_big.png";
import { canUseDOM } from "../../utils";

export default function Game(props) {
  var NONE = 4,
    UP = 3,
    LEFT = 2,
    DOWN = 1,
    RIGHT = 11,
    WAITING = 5,
    PAUSE = 6,
    PLAYING = 7,
    COUNTDOWN = 8,
    EATEN_PAUSE = 9,
    DYING = 10,
    WON = 11,
    Game = {};

  Game.FPS = 20;

  let imgObj = null;
  let intervalID = null;

  Game.Ghost = function(game, map, ghostIndex, spriteConfig) {
    var position = null,
      direction = null,
      eatable = null,
      eaten = null,
      due = null,
      currentFrame = 0,
      animationTick = 0;

    function getNewCoord(dir, current) {
      var speed = isVunerable() ? 1 : isHidden() ? 4 : 2,
        xSpeed = (dir === LEFT && -speed) || (dir === RIGHT && speed) || 0,
        ySpeed = (dir === DOWN && speed) || (dir === UP && -speed) || 0;

      return {
        x: addBounded(current.x, xSpeed),
        y: addBounded(current.y, ySpeed)
      };
    }

    // Collision detection(walls) is done when a ghost lands on an
    // exact block, make sure they dont skip over it
    //
    function addBounded(x1, x2) {
      var rem = x1 % 10,
        result = rem + x2;
      if (rem !== 0 && result > 10) {
        return x1 + (10 - rem);
      } else if (rem > 0 && result < 0) {
        return x1 - rem;
      }
      return x1 + x2;
    }

    function isVunerable() {
      return eatable !== null;
    }

    function isDangerous() {
      return eaten === null;
    }

    function isHidden() {
      return eatable === null && eaten !== null;
    }

    function getRandomDirection() {
      var moves = direction === UP ? [UP, UP, UP, DOWN] : [UP, DOWN, DOWN, DOWN];
      return moves[Math.floor(Math.random() * 4)];
    }

    function reset() {
      eaten = null;
      eatable = null;
      position = ghostIndex === 0 ? { x: 50, y: 10 } : { x: 130, y: 10 }; // ghost pos start HERE
      direction = getRandomDirection();
      due = getRandomDirection();
    }

    function onWholeSquare(x) {
      return x % 10 === 0;
    }

    function oppositeDirection(dir) {
      return (dir === LEFT && RIGHT) || (dir === RIGHT && LEFT) || (dir === UP && DOWN) || UP;
    }

    function makeEatable() {
      direction = oppositeDirection(direction);
      eatable = game.getTick();
    }

    function eat() {
      eatable = null;
      eaten = game.getTick();
    }

    function pointToCoord(x) {
      return Math.round(x / 10);
    }

    function nextSquare(x, dir) {
      var rem = x % 10;
      if (rem === 0) {
        return x;
      } else if (dir === RIGHT || dir === DOWN) {
        return x + (10 - rem);
      } else {
        return x - rem;
      }
    }

    function onGridSquare(pos) {
      return onWholeSquare(pos.y) && onWholeSquare(pos.x);
    }

    function draw(ctx) {
      var s = map.blockSize,
        top = (position.y / 10) * s,
        left = (position.x / 10) * s;

      // Make the frames loop
      // Rows and columns start from 0
      if (animationTick % spriteConfig.numberOfFrames === 0) {
        currentFrame = (currentFrame + 1) % spriteConfig.numberOfFrames;
      }
      animationTick++;

      // Update rows and columns
      let column = spriteConfig.column + (currentFrame % spriteConfig.numColumns);
      let row = spriteConfig.row + Math.floor(currentFrame / spriteConfig.numColumns);

      ctx.drawImage(imgObj, column * spriteConfig.frameWidth, row * spriteConfig.frameHeight, spriteConfig.frameWidth, spriteConfig.frameHeight, left, top, spriteConfig.figureWidth, spriteConfig.figureHeight);
    }

    function pane(pos) {
      if (pos.y === 100 && pos.x >= 210 && direction === RIGHT) {
        return { y: 100, x: -10 };
      }

      if (pos.y === 100 && pos.x <= -10 && direction === LEFT) {
        return (position = { y: 100, x: 210 });
      }

      return false;
    }

    function move(ctx) {
      var oldPos = position,
        onGrid = onGridSquare(position),
        npos = null;

      if (due !== direction) {
        npos = getNewCoord(due, position);

        if (
          onGrid &&
          map.isFloorSpace({
            y: pointToCoord(nextSquare(npos.y, due)),
            x: pointToCoord(nextSquare(npos.x, due))
          })
        ) {
          direction = due;
        } else {
          npos = null;
        }
      }

      if (npos === null) {
        npos = getNewCoord(direction, position);
      }

      if (
        onGrid &&
        map.isWallSpace({
          y: pointToCoord(nextSquare(npos.y, direction)),
          x: pointToCoord(nextSquare(npos.x, direction))
        })
      ) {
        due = getRandomDirection();
        return move(ctx);
      }

      position = npos;

      var tmp = pane(position);
      if (tmp) {
        position = tmp;
      }

      due = getRandomDirection();

      return {
        new: position,
        old: oldPos
      };
    }

    return {
      eat: eat,
      isVunerable: isVunerable,
      isDangerous: isDangerous,
      makeEatable: makeEatable,
      reset: reset,
      move: move,
      draw: draw
    };
  };

  Game.User = function(game, map, spriteConfig) {
    var position = null,
      direction = null,
      oldDirection = null,
      due = null,
      currentFrame = 0,
      animationTick = 0,
      keyMap = {};

    keyMap[KEY.ARROW_LEFT] = LEFT;
    keyMap[KEY.ARROW_UP] = UP;
    keyMap[KEY.ARROW_RIGHT] = RIGHT;
    keyMap[KEY.ARROW_DOWN] = DOWN;

    function initUser() {
      newGame();
    }

    function newGame() {
      resetPosition();
    }

    function resetPosition() {
      position = { x: 10, y: 10 }; // hero user position
      direction = DOWN;
      due = LEFT;
    }

    function reset() {
      initUser();
      resetPosition();
    }

    function keyDown(e) {
      if (typeof keyMap[e.keyCode] !== "undefined") {
        due = keyMap[e.keyCode];
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      return true;
    }

    function getNewCoord(dir, current) {
      return {
        x: current.x + ((dir === LEFT && -2) || (dir === RIGHT && 2) || 0),
        y: current.y + ((dir === DOWN && 2) || (dir === UP && -2) || 0)
      };
    }

    function onWholeSquare(x) {
      return x % 10 === 0;
    }

    function pointToCoord(x) {
      return Math.round(x / 10);
    }

    function nextSquare(x, dir) {
      var rem = x % 10;
      if (rem === 0) {
        return x;
      } else if (dir === RIGHT || dir === DOWN) {
        return x + (10 - rem);
      } else {
        return x - rem;
      }
    }

    function next(pos, dir) {
      return {
        y: pointToCoord(nextSquare(pos.y, dir)),
        x: pointToCoord(nextSquare(pos.x, dir))
      };
    }

    function onGridSquare(pos) {
      return onWholeSquare(pos.y) && onWholeSquare(pos.x);
    }

    function isOnSamePlane(due, dir) {
      return ((due === LEFT || due === RIGHT) && (dir === LEFT || dir === RIGHT)) || ((due === UP || due === DOWN) && (dir === UP || dir === DOWN));
    }

    function move() {
      var npos = null,
        nextWhole = null,
        oldPosition = position,
        block = null;

      if (due !== direction) {
        npos = getNewCoord(due, position);

        if (isOnSamePlane(due, direction) || (onGridSquare(position) && map.isFloorSpace(next(npos, due)))) {
          direction = due;
        } else {
          npos = null;
        }
      }

      if (npos === null) {
        npos = getNewCoord(direction, position);
      }

      if (onGridSquare(position) && map.isWallSpace(next(npos, direction))) {
        oldDirection = direction;
        direction = NONE;
      }

      //GOAL position
      if (npos.x > 220 && npos.y === 60) {
        game.won();
      }

      if (direction === NONE) {
        return { new: position, old: position };
      }

      if (npos.y === 100 && npos.x >= 120 && direction === RIGHT) {
        npos = { y: 100, x: -10 };
      }

      if (npos.y === 100 && npos.x <= -12 && direction === LEFT) {
        npos = { y: 100, x: 120 };
      }

      position = npos;
      nextWhole = next(position, direction);

      block = map.block(nextWhole);

      if (((isMidSquare(position.y) || isMidSquare(position.x)) && block === Game.BISCUIT) || block === Game.PILL) {
        map.setBlock(nextWhole, Game.EMPTY);

        if (block === Game.PILL) {
          game.eatenPill();
        }
      }

      return {
        new: position,
        old: oldPosition
      };
    }

    function isMidSquare(x) {
      var rem = x % 10;
      return rem > 3 || rem < 7;
    }

    function drawDead(ctx, amount) {
      var size = map.blockSize;

      if (amount >= 1) {
        return;
      }

      if (animationTick % spriteConfig.numberOfFrames === 0) {
        currentFrame = (currentFrame + 1) % spriteConfig.numberOfFrames;
      }
      animationTick++;

      // Update rows and columns
      let column = spriteConfig.column + (currentFrame % spriteConfig.numColumns);
      let row = spriteConfig.row + Math.floor(currentFrame / spriteConfig.numColumns);
      ctx.drawImage(imgObj, column * spriteConfig.frameWidth, row * spriteConfig.frameHeight, spriteConfig.frameWidth, spriteConfig.frameHeight * (1 - amount), (position.x / 10) * size, (position.y / 10) * size, spriteConfig.figureWidth, spriteConfig.figureHeight * (1 - amount));
    }

    function draw(ctx) {
      var s = map.blockSize,
        top = (position.y / 10) * s,
        left = (position.x / 10) * s;

      if (animationTick % spriteConfig.numberOfFrames === 0) {
        currentFrame = (currentFrame + 1) % spriteConfig.numberOfFrames;
      }
      animationTick++;

      // Update rows and columns
      let column = spriteConfig.column + (currentFrame % spriteConfig.numColumns);
      let row = spriteConfig.row + Math.floor(currentFrame / spriteConfig.numColumns);

      ctx.drawImage(imgObj, column * spriteConfig.frameWidth, row * spriteConfig.frameHeight, spriteConfig.frameWidth, spriteConfig.frameHeight, left, top, spriteConfig.figureWidth, spriteConfig.figureHeight);
    }

    initUser();

    return {
      draw: draw,
      drawDead: drawDead,
      keyDown: keyDown,
      move: move,
      newGame: newGame,
      reset: reset,
      resetPosition: resetPosition
    };
  };

  Game.Map = function(size) {
    var height = null,
      width = null,
      blockSize = size,
      pillSize = 0,
      map = null;

    function withinBounds(y, x) {
      return y >= 0 && y < height && x >= 0 && x < width;
    }

    function isWall(pos) {
      return withinBounds(pos.y, pos.x) && map[pos.y][pos.x] === Game.WALL;
    }

    function isFloorSpace(pos) {
      if (!withinBounds(pos.y, pos.x)) {
        return false;
      }
      var peice = map[pos.y][pos.x];
      return peice === Game.EMPTY || peice === Game.BISCUIT || peice === Game.PILL;
    }

    function drawWall(ctx) {
      var i, j, p, line;

      ctx.strokeStyle = "#339586";
      ctx.lineWidth = 3;
      ctx.lineCap = "round";

      for (i = 0; i < Game.WALLS.length; i += 1) {
        line = Game.WALLS[i];
        ctx.beginPath();

        for (j = 0; j < line.length; j += 1) {
          p = line[j];

          if (p.move) {
            ctx.moveTo(p.move[0] * blockSize, p.move[1] * blockSize);
          } else if (p.line) {
            //   ctx.shadowColor = "#339586";
            //   ctx.shadowBlur = 5;
            ctx.lineTo(p.line[0] * blockSize, p.line[1] * blockSize);
          } else if (p.curve) {
            ctx.quadraticCurveTo(p.curve[0] * blockSize, p.curve[1] * blockSize, p.curve[2] * blockSize, p.curve[3] * blockSize);
          }
        }
        ctx.stroke();
      }
    }

    function reset() {
      map = JSON.parse(JSON.stringify(Game.MAP));
      height = map.length;
      width = map[0].length;
    }

    function block(pos) {
      return map[pos.y][pos.x];
    }

    function setBlock(pos, type) {
      map[pos.y][pos.x] = type;
    }

    function drawPills(ctx) {
      if (++pillSize > 30) {
        pillSize = 0;
      }

      for (var i = 0; i < height; i += 1) {
        for (var j = 0; j < width; j += 1) {
          if (map[i][j] === Game.PILL) {
            ctx.beginPath();

            ctx.fillStyle = "#000";
            ctx.fillRect(j * blockSize, i * blockSize, blockSize, blockSize);

            ctx.fillStyle = "#FFF";
            ctx.arc(j * blockSize + blockSize / 2, i * blockSize + blockSize / 2, Math.abs(5 - pillSize / 3), 0, Math.PI * 2, false);
            ctx.fill();
            ctx.closePath();
          }
        }
      }
    }

    function draw(ctx) {
      var i,
        j,
        size = blockSize;

      ctx.fillStyle = "#000";
      ctx.fillRect(0, 0, width * size, height * size);

      drawWall(ctx);

      for (i = 0; i < height; i += 1) {
        for (j = 0; j < width; j += 1) {
          drawBlock(i, j, ctx);
        }
      }
    }

    function drawBlock(y, x, ctx) {
      var layout = map[y][x];

      if (layout === Game.PILL) {
        return;
      }

      ctx.beginPath();

      if (layout === Game.EMPTY || layout === Game.BLOCK || layout === Game.BISCUIT) {
        ctx.fillStyle = "#000";
        ctx.fillRect(x * blockSize, y * blockSize, blockSize, blockSize);

        if (layout === Game.BISCUIT) {
          ctx.fillStyle = "#FFF";
          ctx.fillRect(x * blockSize + blockSize / 2.5, y * blockSize + blockSize / 2.5, blockSize / 6, blockSize / 6);
        }
      }
      ctx.closePath();
    }

    reset();

    return {
      draw: draw,
      drawBlock: drawBlock,
      drawPills: drawPills,
      block: block,
      setBlock: setBlock,
      reset: reset,
      isWallSpace: isWall,
      isFloorSpace: isFloorSpace,
      height: height,
      width: width,
      blockSize: blockSize
    };
  };

  var GAME = (function() {
    var state = WAITING,
      ghosts = [],
      ghostSpritesMobile = [
        {
          row: 0,
          column: 0,
          numberOfFrames: 4,
          numColumns: 12,
          figureWidth: 10,
          figureHeight: 10,
          frameWidth: 34,
          frameHeight: 34
        },

        {
          row: 0,
          column: 4,
          numberOfFrames: 4,
          numColumns: 12,
          figureWidth: 10,
          figureHeight: 10,
          frameWidth: 34,
          frameHeight: 34
        }
      ],
      heroSpriteConfigMobile = {
        row: 0,
        column: 8,
        numberOfFrames: 4,
        numColumns: 12,
        figureWidth: 10,
        figureHeight: 10,
        frameWidth: 34,
        frameHeight: 34
      },
      ghostSpritesDesktop = [
        {
          row: 0,
          column: 0,
          numberOfFrames: 4,
          numColumns: 12,
          figureWidth: 25,
          figureHeight: 25,
          frameWidth: 54,
          frameHeight: 54
        },
        {
          row: 0,
          column: 4,
          numberOfFrames: 4,
          numColumns: 12,
          figureWidth: 25,
          figureHeight: 25,
          frameWidth: 54,
          frameHeight: 54
        }
      ],
      heroSpriteConfigDesktop = {
        row: 0,
        column: 8,
        numberOfFrames: 4,
        numColumns: 12,
        figureWidth: 25,
        figureHeight: 25,
        frameWidth: 54,
        frameHeight: 54
      },
      eatenCount = 0,
      tick = 0,
      ghostPos,
      userPos,
      stateChanged = true,
      timerStart = null,
      lastTime = 0,
      ctx = null,
      map = null,
      user = null,
      stored = null;

    function getTick() {
      return tick;
    }

    function dialog(text) {
      var messageContainer = document.getElementById("message");
      if (messageContainer) {
        messageContainer.innerHTML = text;
      }
    }

    function startLevel() {
      user.resetPosition();
      for (var i = 0; i < ghosts.length; i += 1) {
        ghosts[i].reset();
      }

      timerStart = tick;
      setGameState(COUNTDOWN);
    }

    function startNewGame() {
      setGameState(WAITING);
      user.reset();
      map.reset();
      map.draw(ctx);
      startLevel();

      // show replay button
      replayButton.current.style.display = "none";

      // hide arrow navigation
      navigationButtons.current.style.display = "block";
    }

    function keyDown(e) {
      if (e.keyCode === KEY.SPACEBAR) {
        startNewGame();
      } else if (e.keyCode === KEY.P && state === PAUSE) {
        map.draw(ctx);
        setGameState(stored);
      } else if (e.keyCode === KEY.P) {
        stored = state;
        setGameState(PAUSE);

        map.draw(ctx);
        dialog("Paused");
      } else if (state !== PAUSE) {
        return user.keyDown(e);
      }
      return true;
    }

    function loseLife() {
      setGameState(WAITING);
      // show replay button
      replayButton.current.style.display = "block";

      // hide arrow navigation
      navigationButtons.current.style.display = "none";
    }

    function setGameState(nState) {
      state = nState;
      stateChanged = true;
    }

    function collided(user, ghost) {
      return Math.sqrt(Math.pow(ghost.x - user.x, 2) + Math.pow(ghost.y - user.y, 2)) < 10;
    }

    function redrawBlock(pos) {
      map.drawBlock(Math.floor(pos.y / 10), Math.floor(pos.x / 10), ctx);
      map.drawBlock(Math.ceil(pos.y / 10), Math.ceil(pos.x / 10), ctx);
    }

    function mainDraw() {
      var u, i, len, nScore;

      ghostPos = [];

      for (i = 0, len = ghosts.length; i < len; i += 1) {
        ghostPos.push(ghosts[i].move(ctx));
      }
      u = user.move(ctx);

      for (i = 0, len = ghosts.length; i < len; i += 1) {
        redrawBlock(ghostPos[i].old);
      }
      redrawBlock(u.old);

      for (i = 0, len = ghosts.length; i < len; i += 1) {
        ghosts[i].draw(ctx);
      }
      user.draw(ctx);

      userPos = u["new"];

      for (i = 0, len = ghosts.length; i < len; i += 1) {
        if (collided(userPos, ghostPos[i]["new"])) {
          if (ghosts[i].isVunerable()) {
            ghosts[i].eat();
            eatenCount += 1;
            nScore = eatenCount * 50;
            user.addScore(nScore);
            setGameState(EATEN_PAUSE);
            timerStart = tick;
          } else if (ghosts[i].isDangerous()) {
            setGameState(DYING);
            timerStart = tick;
          }
        }
      }
    }

    function mainLoop() {
      var diff;

      if (state !== PAUSE) {
        ++tick;
      }

      map.drawPills(ctx);
      var canvas = document.getElementsByTagName("canvas")[0];

      if (state === PLAYING) {
        mainDraw();
      } else if (state === WON && stateChanged) {
        stateChanged = false;
        map.draw(ctx);

        if (canvas && canvas.width > 500) {
          dialog(props.winMessageDesktop);
        } else {
          dialog(props.winMessageMobile);
        }
      } else if (state === WAITING && stateChanged) {
        stateChanged = false;
        map.draw(ctx);

        if (canvas && canvas.width > 500) {
          dialog(props.tryAgainMessageDesktop);
        } else {
          dialog(props.tryAgainMessageMobile);
        }
      } else if (state === EATEN_PAUSE && tick - timerStart > Game.FPS / 3) {
        map.draw(ctx);
        setGameState(PLAYING);
      } else if (state === DYING) {
        if (tick - timerStart > Game.FPS * 2) {
          loseLife();
        } else {
          redrawBlock(userPos);
          for (var i = 0, len = ghosts.length; i < len; i += 1) {
            redrawBlock(ghostPos[i].old);
            ghostPos.push(ghosts[i].draw(ctx));
          }
          user.drawDead(ctx, (tick - timerStart) / (Game.FPS * 2));
        }
      } else if (state === COUNTDOWN) {
        diff = 1 + Math.floor((timerStart - tick) / Game.FPS);

        if (diff === 0) {
          map.draw(ctx);
          setGameState(PLAYING);
          dialog("");
        } else {
          if (diff !== lastTime) {
            lastTime = diff;
            map.draw(ctx);
            // dialog(props.countdownMessage + " " + diff);
          }
        }
      }
    }

    function eatenPill() {
      // audio.play("eatpill");
      timerStart = tick;
      eatenCount = 0;
      for (var i = 0; i < ghosts.length; i += 1) {
        ghosts[i].makeEatable(ctx);
      }
    }

    function completedLevel() {
      setGameState(WAITING);
      map.reset();
      user.newGame();
      startLevel();
    }

    function won() {
      setGameState(WON);
    }

    function keyPress(e) {
      if (state !== WAITING && state !== PAUSE) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    function drawCleanGame(wrapper, canvas) {
      var i,
        len,
        ghost,
        blockSize = wrapper?.offsetWidth / 23;

      if (!canvas) {
        canvas = document.createElement("canvas");
      }

      canvas.setAttribute("width", blockSize * 23 + "px");
      canvas.setAttribute("height", blockSize * 12 + 30 + "px");

      wrapper.appendChild(canvas);

      ctx = canvas.getContext("2d");

      var heroSprite = heroSpriteConfigDesktop,
        ghostSprtie = ghostSpritesDesktop;

      //select right sizes for mobile, tablet  or desktop
      if (wrapper?.offsetWidth <= 300) {
        heroSprite = heroSpriteConfigMobile;
        ghostSprtie = ghostSpritesMobile;
      } else if (wrapper?.offsetWidth <= 400) {
        ghostSprtie = ghostSpritesMobile.map(x => {
          return { ...x, figureWidth: 17, figureHeight: 17 };
        });
        heroSprite = {
          ...heroSpriteConfigMobile,
          figureWidth: 17,
          figureHeight: 17
        };
      }

      map = new Game.Map(blockSize);
      user = new Game.User(
        {
          completedLevel: completedLevel,
          eatenPill: eatenPill,
          won: won
        },
        map,
        heroSprite
      );

      for (i = 0, len = ghostSprtie.length; i < len; i += 1) {
        ghost = new Game.Ghost({ getTick: getTick }, map, i, ghostSprtie[i]);
        ghosts.push(ghost);
      }

      map.draw(ctx);
    }

    function resize(wrapper) {
      var canvas = document.getElementsByTagName("canvas")[0];
      //select correct sprit depending on viewport
      imgObj.src = wrapper?.offsetWidth <= 400 ? game_small : game_big;
      ghosts = [];

      if (intervalID) {
        clearInterval(intervalID);
      }

      if (canvas) {
        drawCleanGame(wrapper, canvas);
        startNewGame();
      }
    }

    function init(wrapper) {
      drawCleanGame(wrapper, null);
      loaded(wrapper); // load sprite image
      startNewGame();
    }

    function loaded(wrapper) {
      imgObj = new Image();
      imgObj.onload = function() {
        document.addEventListener("keydown", keyDown, true);
        document.addEventListener("keypress", keyPress, true);

        intervalID = window.setInterval(mainLoop, 1000 / Game.FPS);
      };
      imgObj.src = wrapper?.offsetWidth <= 400 ? game_small : game_big;
    }

    return {
      init: init,
      state: state,
      resize: resize
    };
  })();

  /* Human readable keyCode index */
  var KEY = {
    BACKSPACE: 8,
    TAB: 9,
    NUM_PAD_CLEAR: 12,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESCAPE: 27,
    SPACEBAR: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    PRINT_SCREEN: 44,
    INSERT: 45,
    DELETE: 46,
    SEMICOLON: 59,
    WINDOWS_LEFT: 91,
    WINDOWS_RIGHT: 92,
    SELECT: 93,
    NUM_PAD_ASTERISK: 106,
    NUM_PAD_PLUS_SIGN: 107,
    "NUM_PAD_HYPHEN-MINUS": 109,
    NUM_PAD_FULL_STOP: 110,
    NUM_PAD_SOLIDUS: 111,
    NUM_LOCK: 144,
    SCROLL_LOCK: 145,
    EQUALS_SIGN: 187,
    COMMA: 188,
    "HYPHEN-MINUS": 189,
    FULL_STOP: 190,
    SOLIDUS: 191,
    GRAVE_ACCENT: 192,
    LEFT_SQUARE_BRACKET: 219,
    REVERSE_SOLIDUS: 220,
    RIGHT_SQUARE_BRACKET: 221,
    APOSTROPHE: 222
  };

  (function() {
    /* 0 - 9 */
    for (var i = 48; i <= 57; i++) {
      KEY["" + (i - 48)] = i;
    }
    /* A - Z */
    for (i = 65; i <= 90; i++) {
      KEY["" + String.fromCharCode(i)] = i;
    }
    /* NUM_PAD_0 - NUM_PAD_9 */
    for (i = 96; i <= 105; i++) {
      KEY["NUM_PAD_" + (i - 96)] = i;
    }
    /* F1 - F12 */
    for (i = 112; i <= 123; i++) {
      KEY["F" + (i - 112 + 1)] = i;
    }
  })();

  Game.WALL = 0;
  Game.BISCUIT = 1;
  Game.EMPTY = 2;
  Game.BLOCK = 3;
  Game.PILL = 4;

  Game.MAP = [
    [0, 0, 0, 2, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 2, 0, 0, 0],
    [0, 1, 0, 2, 0, 1, 0, 2, 0, 1, 1, 1, 1, 1, 0, 0, 0, 1, 0, 2, 0, 1, 0],
    [0, 1, 0, 2, 0, 1, 0, 2, 0, 1, 0, 0, 0, 1, 1, 1, 1, 1, 0, 2, 0, 1, 0],
    [0, 1, 0, 0, 0, 1, 0, 2, 0, 1, 0, 2, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0],
    [0, 1, 1, 1, 1, 1, 0, 2, 0, 1, 0, 2, 0, 1, 0, 2, 0, 1, 1, 1, 1, 1, 0],
    [0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 2, 0, 1, 0, 2, 0, 0, 0, 0, 0, 1, 0],
    [2, 2, 2, 2, 0, 1, 1, 1, 1, 1, 0, 2, 0, 1, 0, 2, 2, 2, 2, 2, 0, 1, 2],
    [2, 2, 2, 2, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 2, 2, 2, 2, 2, 0, 1, 0],
    [2, 2, 2, 2, 0, 1, 0, 2, 0, 1, 1, 1, 1, 1, 0, 2, 2, 2, 2, 2, 0, 1, 0],
    [2, 2, 2, 2, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 0, 0, 0],
    [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
    [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2]
    //   [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
    //   [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
    //   [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2]
    //   [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
    //   [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
    //   [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
    //   [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2]
  ];

  Game.WALLS = [
    // first 4

    [{ move: [0.5, 0.5] }, { line: [2.5, 0.5] }],
    [{ move: [2.5, 0.5] }, { line: [2.5, 3.5] }],
    [{ move: [2.5, 3.5] }, { line: [4.5, 3.5] }],
    [{ move: [4.5, 3.5] }, { line: [4.5, 0.5] }],
    [{ move: [4.5, 0.5] }, { line: [6.5, 0.5] }],
    [{ move: [6.5, 0.5] }, { line: [6.5, 5.5] }],
    [{ move: [6.5, 5.5] }, { line: [8.5, 5.5] }],
    [{ move: [8.5, 5.5] }, { line: [8.5, 0.5] }],
    [{ move: [8.5, 0.5] }, { line: [14.5, 0.5] }],
    [{ move: [14.5, 0.5] }, { line: [14.5, 1.5] }],
    [{ move: [14.5, 1.5] }, { line: [16.5, 1.5] }],
    [{ move: [16.5, 1.5] }, { line: [16.5, 0.5] }],
    [{ move: [16.5, 0.5] }, { line: [18.5, 0.5] }],
    [{ move: [18.5, 0.5] }, { line: [18.5, 3.5] }],
    [{ move: [18.5, 3.5] }, { line: [20.5, 3.5] }],
    [{ move: [20.5, 3.5] }, { line: [20.5, 0.5] }],
    [{ move: [20.5, 0.5] }, { line: [22.5, 0.5] }],
    [{ move: [22.5, 0.5] }, { line: [22.5, 9.5] }],
    [{ move: [22.5, 9.5] }, { line: [20.5, 9.5] }],
    [{ move: [20.5, 9.5] }, { line: [20.5, 5.5] }],
    [{ move: [20.5, 9.5] }, { line: [20.5, 5.5] }],
    [{ move: [20.5, 5.5] }, { line: [16.5, 5.5] }],
    [{ move: [16.5, 5.5] }, { line: [16.5, 3.5] }],
    [{ move: [16.5, 3.5] }, { line: [14.5, 3.5] }],
    [{ move: [14.5, 3.5] }, { line: [14.5, 9.5] }],
    [{ move: [14.5, 9.5] }, { line: [8.5, 9.5] }],
    [{ move: [8.5, 9.5] }, { line: [8.5, 7.5] }],
    [{ move: [8.5, 7.5] }, { line: [6.5, 7.5] }],
    [{ move: [6.5, 7.5] }, { line: [6.5, 9.5] }],
    [{ move: [6.5, 7.5] }, { line: [6.5, 9.5] }],
    [{ move: [6.5, 9.5] }, { line: [4.5, 9.5] }],
    [{ move: [4.5, 9.5] }, { line: [4.5, 5.5] }],
    [{ move: [4.5, 5.5] }, { line: [0.5, 5.5] }],
    [{ move: [0.5, 0.5] }, { line: [0.5, 5.5] }],

    // zero hole
    [{ move: [10.5, 2.5] }, { line: [12.5, 2.5] }],
    [{ move: [12.5, 2.5] }, { line: [12.5, 7.5] }],
    [{ move: [12.5, 7.5] }, { line: [10.5, 7.5] }],
    [{ move: [10.5, 2.5] }, { line: [10.5, 7.5] }]
  ];

  const [windowWidth, setWindowWidth] = useState(canUseDOM() && window.innerWidth);
  const gameContainer = useRef();
  const replayButton = useRef();
  const navigationButtons = useRef();

  const updateWindowDimensions = useCallback(() => {
    if (canUseDOM() && (windowWidth + 20 < window.innerWidth || windowWidth - 20 > window.innerWidth)) {
      GAME.resize(gameContainer.current);
      setWindowWidth(window.innerWidth);
    }
  }, [GAME, windowWidth]);

  useMount(() => {
    if (canUseDOM()) {
      GAME.init(gameContainer.current);

      window.addEventListener("resize", updateWindowDimensions);
    }
  });

  const fakeKeyPress = keyCode => {
    var evt = new KeyboardEvent("keydown", {
      keyCode: keyCode,
      which: keyCode
    });

    document.dispatchEvent(evt);
  };

  const arrowUpClick = () => {
    fakeKeyPress(KEY.ARROW_UP);
  };
  const arrowDownClick = () => {
    fakeKeyPress(KEY.ARROW_DOWN);
  };
  const arrowRightClick = () => {
    fakeKeyPress(KEY.ARROW_RIGHT);
  };
  const arrowLeftClick = () => {
    fakeKeyPress(KEY.ARROW_LEFT);
  };

  const spaceClick = () => {
    fakeKeyPress(KEY.SPACEBAR);
  };

  return (
    <div className="game-container">
      <div id="game" ref={gameContainer} />

      <div className={"message"}>
        <span id={"message"}></span>
      </div>

      <div className={"game-navigation"} ref={replayButton}>
        <div className={"row"}>
          <button className={"navigation-button replay"} onClick={spaceClick}>
            <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24">
              <g>
                <rect fill="none" height="24" width="24" />
                <rect fill="none" height="24" width="24" />
                <rect fill="none" height="24" width="24" />
              </g>
              <g>
                <path d="M12,5V1L7,6l5,5V7c3.31,0,6,2.69,6,6s-2.69,6-6,6s-6-2.69-6-6H4c0,4.42,3.58,8,8,8s8-3.58,8-8S16.42,5,12,5z" />
              </g>
            </svg>
          </button>
        </div>
      </div>

      <div className={"game-navigation"} ref={navigationButtons}>
        <div className={"row"}>
          <button className={"navigation-button up"} onClick={arrowUpClick}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
            </svg>
          </button>
        </div>
        <div className={"row"}>
          <button className={"navigation-button left"} onClick={arrowLeftClick}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
            </svg>
          </button>

          <button className={"navigation-button down"} onClick={arrowDownClick}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
            </svg>
          </button>

          <button className={"navigation-button right"} onClick={arrowRightClick}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

Game.propTypes = {
  winMessageDesktop: PropTypes.string.isRequired,
  winMessageMobile: PropTypes.string.isRequired,
  tryAgainMessageDesktop: PropTypes.string.isRequired,
  tryAgainMessageMobile: PropTypes.string.isRequired
};

Game.defaultProps = {
  winMessageDesktop: "Congratulations you won! Press space to start a new game",
  winMessageMobile: "Congratulations you won!",
  tryAgainMessageDesktop: "Try again! Press space to start a new game",
  tryAgainMessageMobile: "Try again!"
};
